/**
 * Device Storage API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface DeviceCommand { 
    data?: string;
    deviceCommandType?: DeviceCommand.DeviceCommandTypeEnum;
}
export namespace DeviceCommand {
    export const DeviceCommandTypeEnum = {
        DropOffRelease: 'DROP_OFF_RELEASE',
        DropOffReleaseLong: 'DROP_OFF_RELEASE_LONG'
    } as const;
    export type DeviceCommandTypeEnum = typeof DeviceCommandTypeEnum[keyof typeof DeviceCommandTypeEnum];
}


export type DeviceCommandTypeEnum = typeof DeviceCommand.DeviceCommandTypeEnum[keyof typeof DeviceCommand.DeviceCommandTypeEnum];
